export const APP_CONFIG = {
appName: 'SOLV Total Rewards',
frontend: 'https://solvtotalrewards.com',
apiHash: 'https://solvtotalrewards.com/api/1.0',
api: 'https://us.servicegateway.io',
trustModel: false,
authHeaders: {
xServiceProvider: 'solv-prod-frontend',
'tenant-id': 'f98db73c-0748-44aa-b64c-e4591be73dfa',
'consumer-id': '11345378-c3e8-47af-b5d9-887b6714e497',
},
provider: 'solv-prod-frontend',
multilingual: false,
testMode: false,
testManualLogin: true,
demoMode: false,
chatEnabled: false,
gtm: 'GTM-WXVMFJCD',
copyright: '<small>&copy; ' + new Date().getFullYear() +
' Gallagher | All Rights Reserved. Powered by Core.' + '</small>',
navigation: {
navType: 'top',
collapsibleSidenav: false,
headerStyle: 'transparent',
categoryNav: true,
navigationOrder: 'displayOrder',
}
};
